import Chip from "@mui/material/Chip"
import { getEstadoConfig } from "../utils/estados"

// Chip de estado reutilizable con color semántico.
export default function EstadoChip({ estado, size = "small" }) {
  const { color, label } = getEstadoConfig(estado)

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      variant={color === "default" ? "outlined" : "filled"}
      sx={{
        borderRadius: 1.5,
        px: 0.5,
        ...(color !== "default" && {
          color: "#fff",
        }),
      }}
    />
  )
}
